import type { z } from "zod";

import * as transport from "../../../../transport";
import { ProtocolTransaction_fromPosConnectorResponse } from "../../shared/protocol-transaction-from-pos-connector-response";
import type { RefundResponseSchema } from "./schemas";

const resolve = transport.Resolve<"Terminal_refund">();

export function getApprovedResponse(options: {
	event: z.infer<typeof RefundResponseSchema.shape.data>;
	reference: string;
}): {
	response: ReturnType<typeof resolve.$Ok>;
	getPageProps: () => {
		currency: string | undefined;
		totalCents: number;
	};
} {
	const { event, reference } = options;

	const response: ReturnType<typeof getApprovedResponse>["response"] =
		resolve.$Ok({
			...ProtocolTransaction_fromPosConnectorResponse(event),
			$type: "Approved",
			externalReference: reference,
			type: "REFUND",
		});

	const getPageProps: ReturnType<
		typeof getApprovedResponse
	>["getPageProps"] = () =>
		({
			currency: event.currency,
			totalCents: event.amount,
		}) as const;

	return { response, getPageProps };
}
